"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsConditionsCheckbox = void 0;
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _ExpandableTextBlock = require("../ExpandableTextBlock");
var _StyledComponentsLegalForm = require("../Forms/LegalForm/StyledComponentsLegalForm");
var _Loading = require("../Loading");
var _jsxRuntime = require("react/jsx-runtime");
const TermsConditionsCheckbox = props => {
  const {
    config
  } = props;
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const headers = (0, _hooks.useCustomHeaders)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [terms, setTerms] = (0, _react.useState)();
  const [showPrivacyPolicy, setShowPrivacyPolicy] = (0, _react.useState)(false);
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const form = (0, _reactHookForm.useFormContext)();
  const {
    watch,
    setValue,
    trigger,
    formState: {
      isSubmitting
    }
  } = form;
  const isCustomTextAvailable = config?.customText?.isEnabled;
  const getTerms = (0, _react.useCallback)(async () => {
    try {
      if (registrationData?.customerId) {
        const termsResponse = await (0, _globalApiClientReact.getCustomerRequiredTerms)(api, registrationData.customerId, {}, headers);
        const result = new _models.FetchResult(termsResponse.status);
        if (result.isSuccess() && termsResponse.data.collection.length > 0) {
          const isShowPrivacyPolicy = termsResponse.data.collection.some(requiredTerm => requiredTerm.type === 'PrivacyPolicy');
          setShowPrivacyPolicy(isShowPrivacyPolicy);
          setTerms(termsResponse.data.collection[0]);
        }
      }
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.cannotUpdate,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotUpdate
        }),
        type: _interfaces.MessageType.error
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [tenant, registrationData]);
  (0, _react.useEffect)(() => {
    if (config?.termsAndConditions?.isAvailable) {
      getTerms();
    }
  }, [config, registrationData, getTerms]);
  const values = watch();
  const termId = values.termsAndConditions?.termId;
  if (config?.termsAndConditions?.isAvailable && !terms) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      order: config?.termsAndConditions?.displayOrder
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
      name: "termsAndConditions.termId",
      label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
        variant: "body1",
        sx: {
          fontWeight: termId ? 'bold' : 'normal'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.TermsAndConditions,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.TermsAndConditions,
          values: {
            TermsAndConditions_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.TermsAndConditions_Url),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.TermsAndConditions_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.TermsAndConditions_Label
              })
            }),
            LegalDocument1_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument1_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument1_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument1_Link_Label
              })
            }),
            LegalDocument2_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument2_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument2_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument2_Link_Label
              })
            }),
            LegalDocument3_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument3_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument3_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument3_Link_Label
              })
            }),
            LegalDocument4_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument4_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument4_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument4_Link_Label
              })
            }),
            LegalDocument5_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument5_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument5_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument5_Link_Label
              })
            }),
            LegalDocument6_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument6_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument6_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument6_Link_Label
              })
            }),
            LegalDocument7_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument7_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument7_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument7_Link_Label
              })
            }),
            LegalDocument8_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
              color: "textPrimary",
              variant: "body1",
              href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument8_Link),
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.LegalDocument8_Link_Label,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument8_Link_Label
              })
            })
          }
        }), config?.termsAndConditions?.validation?.isMandatory ? '*' : null]
      }),
      value: !!termId,
      onChange: (_e, value) => {
        if (value) {
          setValue('termsAndConditions.termId', terms?.termId, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true
          });
          trigger('termsAndConditions.termId');
        } else {
          setValue('termsAndConditions.termId', undefined, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true
          });
          trigger('termsAndConditions.termId');
        }
      },
      ...config?.termsAndConditions,
      isSubmitting: isSubmitting
    }), showPrivacyPolicy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponentsLegalForm.PolicyText, {
      variant: "body1",
      textAlign: "left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PrivacyPolicy_Text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PrivacyPolicy_Text,
        values: {
          PrivacyPolicy_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
            color: "textPrimary",
            variant: "body1",
            href: (0, _contexts.GetContent)(_Localization.ContentKeys.PrivacyPolicy_Url),
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.PrivacyPolicy_Label,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PrivacyPolicy_Label
            })
          })
        }
      })
    }) : null, isCustomTextAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandableTextBlock.ExpandableTextBlock, {
      dataTestId: getTestId('custom-text-btn-more'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.Custom_text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Custom_text
      })
    }) : null]
  });
};
exports.TermsConditionsCheckbox = TermsConditionsCheckbox;